'use client';

import { NormalizedProduct } from '@ravago/shared/page-data/models/contentful-mapped';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableHeader } from '@ravago/shared/radiance/components/table/components/TableHeader/TableHeader';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { TableSubheader } from '@ravago/shared/radiance/components/table/components/TableSubheader/TableSubheader';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   products: NormalizedProduct[];
   totalColumns: number;
}

export const ProductCompareGeneralInfo = ({ products, totalColumns }: Props) => {
   const translate = useTranslations();

   return (
      <>
         <TableRow>
            <TableSubheader colSpan={totalColumns}>{translate('page-consumer.product-compare.table.general-information')}</TableSubheader>
         </TableRow>
         <TableRow>
            <TableHeader>
               <Typography variant="body-highlight">{translate('page-consumer.product-compare.table.brand')}</Typography>
            </TableHeader>
            {products.map((product) => (
               <TableCell verticalAlign="top" key={`brand-${product.id}`}>
                  {product.brand?.name ?? '-'}
               </TableCell>
            ))}
         </TableRow>
         <TableRow>
            <TableHeader>
               <Typography variant="body-highlight">{translate('page-consumer.product-compare.table.producer')}</Typography>
            </TableHeader>
            {products.map((product) => (
               <TableCell verticalAlign="top" key={`producer-${product.id}`}>
                  {product.brand?.producer?.name ?? '-'}
               </TableCell>
            ))}
         </TableRow>
         <TableRow>
            <TableHeader>
               <Typography variant="body-highlight">{translate('page-consumer.product-compare.table.polymer')}</Typography>
            </TableHeader>
            {products.map((product) => (
               <TableCell verticalAlign="top" key={`polymer-${product.id}`}>
                  {product.polymerGroup ?? '-'}
               </TableCell>
            ))}
         </TableRow>
         <TableRow>
            <TableHeader>
               <Typography variant="body-highlight">{translate('page-consumer.product-compare.table.form')}</Typography>
            </TableHeader>
            {products.map((product) => (
               <TableCell verticalAlign="top" key={`form-${product.id}`}>
                  {product.form ?? '-'}
               </TableCell>
            ))}
         </TableRow>
         <TableRow>
            <TableHeader>
               <Typography variant="body-highlight">{translate('page-consumer.product-compare.table.quality')}</Typography>
            </TableHeader>
            {products.map((product) => (
               <TableCell verticalAlign="top" key={`quality-${product.id}`}>
                  {product.quality?.name ?? '-'}
               </TableCell>
            ))}
         </TableRow>
      </>
   );
};
